import React, { useState, useEffect } from "react";
import {
  FaSearch,
  FaTimes,
  FaMinus,
  FaCheck,
  FaChevronDown,
  FaChevronUp,
  FaDownload,
} from "react-icons/fa";
import styled from "styled-components";
import { GiSave } from "react-icons/gi";
import { Radio, Checkbox, Select } from "antd";
const { Option } = Select;
import plus from "../../../assets/images/plus.svg";
import upload from "../../../assets/images/upload.svg";
import { IoIosArrowUp, IoIosArrowDown } from "react-icons/io";
import { MdEdit, MdClose, MdAutorenew } from "react-icons/md";
import { Divs } from "./StyledComponents";
import {
  IconEraser,
  IconSearch,
  IconTrash,
  IconRollback,
  IconExcelWhite,
  IconHistory,
} from "../Layout/Icons";
import { Label } from "../globals";

export const ButtonEditRow = ({ disabled, onClick, type, className }) => {
  return (
    <ButtonSmallStyled
      outline={type == "outline"}
      className={className}
      disabled={disabled || false}
      onClick={onClick}
    >
      <MdEdit color="#FFF" />
    </ButtonSmallStyled>
  );
};

export const ButtonHistoryRow = ({ disabled, onClick, type, className }) => {
  return (
    <ButtonSmallStyled
      outline={type == "outline"}
      className={className}
      disabled={disabled || false}
      onClick={onClick}
    >
      <IconHistory color="#FFF" />
    </ButtonSmallStyled>
  );
};

export const ButtonReloadRow = ({ disabled, onClick, type, className }) => {
  return (
    <ButtonSmallStyled
      outline={type == "outline"}
      className={className}
      disabled={disabled || false}
      onClick={onClick}
    >
      <MdAutorenew color="#FFF" />
    </ButtonSmallStyled>
  );
};

export const ButtonOpenExcel = ({ disabled, onClick, type, className }) => {
  return (
    <ButtonSmallStyled
      outline={type == "outline"}
      className={className}
      disabled={disabled || false}
      onClick={onClick}
    >
      <IconExcelWhite />
    </ButtonSmallStyled>
  );
};

export const ButtonEdit = (props) => {
  return (
    <button
      id={props.id}
      disabled={props.disabled || false}
      className="btn btn-sm "
      style={props.style || { background: "#f29302" }}
      data-toggle="modal"
      data-target="#tableEdit"
      onClick={props.onEdit}
    >
      <FaSearch className="text-white" />
    </button>
  );
};

export const ButtonSmall = ({
  disabled,
  onClick,
  type,
  children,
  className,
}) => {
  return (
    <ButtonSmallStyled
      outline={type == "outline"}
      className={className}
      disabled={disabled || false}
      onClick={onClick}
    >
      {children}
    </ButtonSmallStyled>
  );
};

const ButtonSmallStyled = styled.button`
  width: 29px;
  height: 29px;
  background: ${(props) => (props.outline ? "#ffffff" : "#03B0F7")};
  border: 1px solid #03b0f7;
  border-radius: 3px;
  &:hover {
    background: ${(props) => (!props.outline ? "#ffffff" : "#03B0F7")};
    & svg {
      fill: ${(props) => (props.outline ? "#ffffff" : "#03B0F7")};
    }
  }
`;

export const ButtonSuccessSimple = (props) => {
  return (
    <button className="btn btn-sm btn-success" onClick={props.onClick}>
      <FaCheck className="text-white" />
    </button>
  );
};

export const ButtonDelete = ({ onDelete, disabled, className }) => {
  return (
    <button
      className={`btn btn-sm btn-danger ${className}`}
      onClick={onDelete}
      disabled={disabled}
      style={{
        width: 29,
        height: 29,
        padding: 0,
      }}
    >
      <IconTrash color="#fff" />
    </button>
  );
};

export const ButtonRollback = ({ onClick, disabled, className }) => {
  return (
    <button
      className={`btn btn-sm btn-danger ${className}`}
      onClick={onClick}
      disabled={disabled}
      style={{
        width: 29,
        height: 29,
        padding: 0,
      }}
    >
      <IconRollback />
    </button>
  );
};

export const EditElementClick = (props) => {
  return (
    <a
      className="text-black text-sm"
      id={props.id}
      data-toggle="modal"
      data-target="#tableEdit"
      onClick={props.onEdit}
    >
      {props.name}
    </a>
  );
};

export const CheckBoxInput = (props) => {
  const Comp = props.type == "radio" ? Radio : Checkbox;
  return (
    <div className="d-block">
      <Comp
        className={props.className || ""}
        disabled={props.disabled || false}
        checked={props.checked || false}
        color={props.color}
        name={props.choised || props.name}
        id={props.choised || props.name}
        onChange={props.onChange}
      >
        {props.text && (
          <span className="checkbox_text" style={{ color: props.textColor }}>
            {props.text}
          </span>
        )}
      </Comp>
    </div>
  );
};

export const OrdersTableButton = (props) => {
  return (
    <ButtonOrder
      className={props.class || "btn"}
      float={props.float}
      width={props.width}
      onClick={props.onClick}
    >
      <span className="d-flex justify-content-center align-items-center">
        {props.text}
      </span>
    </ButtonOrder>
  );
};

export const OrderTableFooterButton = (props) => {
  return (
    <SaveButton
      id={props.id}
      color={props.color}
      type="button"
      className="btn"
      // aria-label="Close"
      // data-dismiss="modal"
      onClick={(e) => props.handleSave(e)}
    >
      {props.text == "Išsaugoti" && <GiSave size="20" />}
      {props.text}
    </SaveButton>
  );
};

export const SelectForm = (props) => {
  const [asyncOptions, setAsyncOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (props.loadOptions) {
      setLoading(true);
      props.loadOptions("").then((fetchedOptions) => {
        setAsyncOptions(fetchedOptions);
        setLoading(false);
      });
    }
  }, [props.loadOptions]);

  const handleSearch = async (value) => {
    if (props.loadOptions) {
      setLoading(true);
      const fetchedOptions = await props.loadOptions(value);
      setAsyncOptions(fetchedOptions);
      setLoading(false);
    }
  };

  return (
    <>
      {!!props.placeholder && (
        <Label
          required={props.required}
          className="text-sm-label"
          error={props.error}
        >
          {props.placeholder}
        </Label>
      )}
      <Select
        showSearch
        maxTagCount={props.maxTagCount || 100}
        className={`${props.error ? "error_border" : ""} ${props.className || ""
          }`}
        allowClear={props.allowClear}
        style={{ width: "100%", ...props.style }}
        placeholder={props.onlyPlaceholder || props.placeholder || "Choose"}
        optionFilterProp="children"
        onChange={props.onChange}
        mode={props.mode}
        onBlur={props.onBlur}
        name={`id-${props.selector}`}
        dropdownMatchSelectWidth={
          props.dropdownMatchSelectWidth == undefined
            ? true
            : props.dropdownMatchSelectWidth
        }
        value={props.value || undefined}
        size="default"
        disabled={props.disabled}
        notFoundContent={loading ? <div>Loading...</div> : null}
        filterOption={
          props.filterOption !== undefined ? props.filterOption : true
        }
        onSearch={handleSearch}
      >
        {(props.loadOptions ? asyncOptions : props.options).map(
          (item, index) => (
            <Option key={index} value={item.value}>
              {item.label}
            </Option>
          )
        )}
      </Select>
      {props.error && <div className="text-danger">{props.error}</div>}
    </>
  );
};

export const Button1 = ({ text, option, style, onClick }) => {
  const optionsSelector = (option) => {
    if (option == "plus") {
      return (
        <img
          src={plus}
          width="15"
          style={{
            marginBottom: "4px",
            marginRight: "6px",
            marginLeft: "-2px",
          }}
        />
      );
    } else if (option == "upload") {
      return (
        <img
          src={upload}
          width="15"
          style={{
            marginBottom: "4px",
            marginRight: "6px",
            marginLeft: "-2px",
          }}
        />
      );
    } else if (option == "edit") {
      return (
        <MdEdit
          style={{
            marginBottom: "4px",
            marginRight: "6px",
            marginLeft: "-2px",
          }}
        />
      );
    } else if (option == "minus") {
      return (
        <FaMinus
          style={{
            marginBottom: "4px",
            marginRight: "6px",
            marginLeft: "-2px",
          }}
        />
      );
    } else if (option == "times") {
      return (
        <FaTimes
          style={{
            marginBottom: "4px",
            marginRight: "6px",
            marginLeft: "-2px",
          }}
        />
      );
    }
    return option;
  };
  return (
    <ExpandButton className="button_holder" style={style}>
      <button onClick={onClick} className="btn expand_btn btn-sm btn-circle">
        <span className="expand_btn-text">
          {optionsSelector(option)}
          {text}
        </span>
      </button>
    </ExpandButton>
  );
};

export const ButtonCenter = ({ text, style, onClick }) => {
  const plusSvg = (
    <img
      src={plus}
      width="15"
      style={{
        marginBottom: "4px",
        marginRight: "6px",
        marginLeft: "-2px",
      }}
    />
  );
  return (
    <ExpandButton className="button_holder" style={style}>
      <button
        onClick={onClick}
        className="btn expand_btn btn-sm btn-circle float-center"
      >
        <span className="expand_btn-text">
          {plusSvg}
          {text}
        </span>
      </button>
    </ExpandButton>
  );
};

export const Button2 = ({ onClick, text, style, disabled = false }) => {
  return (
    <ClassicButton
      className="btn btn-success"
      style={style}
      disabled={disabled}
      onClick={onClick}
    >
      {text}
    </ClassicButton>
  );
};

export const ButtonMassActions = ({
  text,
  actions,
  color = "#007bff",
  border = "transparent",
}) => {
  const [active, setActive] = useState(false);
  const [openSubmenuPath, setOpenSubmenuPath] = useState([]);
  const custom_color = color == "white" ? "#212529" : "#fff";

  const closeMenu = () => {
    setActive(false);
    setOpenSubmenuPath([]);
  };

  const handleActionClick = (action, event) => {
    event.stopPropagation();
    if (action.onFunction) {
      action.onFunction();
      closeMenu();
    }
  };

  const renderActions = (items = [], level = 0, parentPath = "root") => (
    <ul className={`mb-0 pl-0 ${level > 0 ? "submenu_box" : ""}`}>
      {items.map((item, idx) => {
        const itemPath = `${parentPath}_${idx}`;

        if (item.hr) {
          return (
            <li key={`hr_${itemPath}`} className="px-0">
              <hr className="my-1" />
            </li>
          );
        }

        const hasChildren = Array.isArray(item.actions) && item.actions.length > 0;
        const isSubmenuOpen = openSubmenuPath[level] === idx;

        return (
          <li
            key={itemPath}
            className={`cursor-pointer mass_action_item ${hasChildren ? "has_children" : ""}`}
            onMouseEnter={() => {
              if (!hasChildren) return;
              setOpenSubmenuPath((prev) => {
                const next = prev.slice(0, level);
                next[level] = idx;
                return next;
              });
            }}
            onClick={(event) => {
              if (hasChildren) {
                event.stopPropagation();
                setOpenSubmenuPath((prev) => {
                  const next = prev.slice(0, level);
                  next[level] = idx;
                  return next;
                });
                return;
              }
              handleActionClick(item, event);
            }}
          >
            <div className="d-flex align-items-center justify-content-between">
              <span>{item.label}</span>
              {hasChildren && <FaChevronDown className="submenu_icon" size={10} />}
            </div>
            {hasChildren && isSubmenuOpen && renderActions(item.actions, level + 1, itemPath)}
          </li>
        );
      })}
    </ul>
  );

  return (
    <ButtonMassActionsStyled
      border={border}
      color={color}
      className="position-relative"
    >
      <button
        className="btn btn-sm d-flex"
        onClick={(event) => {
          event.stopPropagation();
          setActive((prev) => {
            const nextState = !prev;
            if (!nextState) setOpenSubmenuPath([]);
            return nextState;
          });
        }}
      >
        <span>{text}</span>
        <span className="mx-3" />
        <span>
          {active ? (
            <FaChevronUp color={custom_color} />
          ) : (
            <FaChevronDown color={custom_color} />
          )}
        </span>
      </button>
      {active && (
        <div className="select_box mt-1">
          {renderActions(actions)}
        </div>
      )}
    </ButtonMassActionsStyled>
  );
};

const ButtonMassActionsStyled = styled.div`
  .btn {
    background: ${(props) => props.color};
    /* border-radius: 3px; */
    font-style: normal;
    font-size: 11px;
    line-height: 17px;
    text-align: center;
    color: ${(props) => (props.color == "white" ? "#212529" : "#fff")};
    border: 1px solid ${(props) => props.border};
    border-radius: 4px !important;
  }
  .select_box {
    position: absolute;
    // width: 100%;
    min-width: 100%;
    background: #ffffff;
    /* border: 1px solid rgba(0, 0, 0, 0.15); */
    /* border-radius: 0px 0px 4px 4px; */
    padding-top: 5px;
    padding-bottom: 5px;
    z-index: 104;

    /*  */
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    /*  */
    & li {
      font-style: normal;
      font-weight: normal;
      list-style: none;
      font-size: 13px;
      line-height: 17px;
      color: #212529;
      padding: 3px 10px;
      position: relative;
      &:hover {
        color: #000;
        // color: ${(props) => (props.color == "white" ? "black" : "#fff")};
      }
    }

    & .mass_action_item.has_children > .d-flex {
      gap: 8px;
    }

    & .submenu_icon {
      transform: rotate(-90deg);
      flex-shrink: 0;
      margin-left: 6px;
    }

    & .submenu_box {
      position: absolute;
      top: -6px;
      left: calc(100% - 4px);
      min-width: 210px;
      background: #ffffff;
      border: 1px solid #d9d9d9;
      border-radius: 4px;
      padding-top: 5px;
      padding-bottom: 5px;
      z-index: 105;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    }
  }
`;

export const LongButton = ({ text, onClick, style, className }) => {
  return (
    <LongButtonStyle
      className={className ? `${className} text-center` : "text-center"}
      style={style}
      onClick={onClick}
    >
      {text}
    </LongButtonStyle>
  );
};

export const MainBlock = ({
  className = "",
  onChange,
  children,
  action,
  color,
  custom,
  height,
}) => {
  return (
    <MainBlockStyle className={className} color={color} height={height}>
      {custom ? (
        <div
          className="d-flex justify-content-between align-items-center mx-3"
          style={{ cursor: "pointer", height: "100%" }}
        >
          <span className="font-weight-bold w-100">{children}</span>
          <span onClick={onChange}>
            {action ? (
              <IoIosArrowUp title="Sutraukti" color="silver" />
            ) : (
              <IoIosArrowDown color="silver" title="Išskleisti" />
            )}
          </span>
        </div>
      ) : (
        <div
          className="d-flex justify-content-between align-items-center mx-3"
          style={{ cursor: "pointer", height: "100%" }}
          onClick={onChange}
        >
          <span className="font-weight-bold w-100">{children}</span>
          <span>
            {action ? (
              <IoIosArrowUp title="Sutraukti" color="silver" />
            ) : (
              <IoIosArrowDown color="silver" title="Išskleisti" />
            )}
          </span>
        </div>
      )}
    </MainBlockStyle>
  );
};

export const MainBlockWithContext = ({
  onChange,
  children,
  text,
  action,
  color,
  custom,
  height,
}) => {
  return (
    <React.Fragment>
      <Divs>
        <MainBlockStyle color={color} height={height}>
          {custom ? (
            <div
              className="d-flex justify-content-between align-items-center mx-3"
              style={{ cursor: "pointer", height: "100%" }}
            >
              <span className="font-weight-bold w-100">{children}</span>
              <span onClick={onChange}>
                {action ? (
                  <IoIosArrowUp title="Sutraukti" color="silver" />
                ) : (
                  <IoIosArrowDown color="silver" title="Išskleisti" />
                )}
              </span>
            </div>
          ) : (
            <div
              className="d-flex justify-content-between align-items-center mx-3"
              style={{ cursor: "pointer", height: "100%" }}
              onClick={onChange}
            >
              <span className="font-weight-bold w-100">{text}</span>
              <span>
                {action ? (
                  <IoIosArrowUp title="Sutraukti" color="silver" />
                ) : (
                  <IoIosArrowDown color="silver" title="Išskleisti" />
                )}
              </span>
            </div>
          )}
        </MainBlockStyle>

        {action ? <div className="mb-2">{children}</div> : null}
      </Divs>
    </React.Fragment>
  );
};

export const MiniBlock = ({ onChange, children, action, color, Collapse }) => {
  return (
    <MiniBlockStyle color={color}>
      <div
        className="d-flex justify-content-between align-items-center mx-3"
        style={{ cursor: "pointer", height: "100%" }}
        onClick={onChange}
      >
        <div className="font-weight-bold w-100">{children}</div>
        <div>
          {Collapse &&
            (action ? (
              <IoIosArrowUp title="Sutraukti" color="silver" />
            ) : (
              <IoIosArrowDown color="silver" title="Išskleisti" />
            ))}
        </div>
      </div>
    </MiniBlockStyle>
  );
};
MiniBlock.defaultProps = {
  Collapse: true,
};

export const MiniBlockOrderRows = ({
  onChange,
  children,
  action,
  color,
  goodsAddRow,
  goodsAddRowClick,
  editAction,
}) => {
  const itsTrueActions = editAction && action;
  return (
    <MiniBlockStyle color={color}>
      <div
        className="d-flex justify-content-between align-items-center mx-3"
        style={{ cursor: "pointer", height: "100%" }}
      >
        <span className="font-weight-bold w-100" onClick={onChange}>
          {children}
        </span>
        <span className="d-flex">
          <div className="mr-3">
            {itsTrueActions &&
              (goodsAddRow ? (
                <MdClose color="red" onClick={goodsAddRowClick} />
              ) : (
                <MdEdit color="green" onClick={goodsAddRowClick} />
              ))}
          </div>
          <div onClick={onChange}>
            {action ? (
              <IoIosArrowUp title="Sutraukti" color="silver" />
            ) : (
              <IoIosArrowDown color="silver" title="Išskleisti" />
            )}
          </div>
        </span>
      </div>
    </MiniBlockStyle>
  );
};
MiniBlockOrderRows.defaultProps = {
  editAction: true,
};

export const MiniBlockOrderRowsCustom = ({
  onChange,
  children,
  action,
  color,
  goodsAddRow,
  goodsAddRowClick,
  editAction,
}) => {
  const itsTrueActions = editAction && action;
  return (
    <MiniBlockStyle color={color}>
      <div
        className="d-flex justify-content-between align-items-center mx-3"
        style={{ cursor: "pointer", height: "100%" }}
      >
        <span className="font-weight-bold w-100">{children}</span>
        <span className="d-flex">
          <div className="mr-3">
            {itsTrueActions &&
              (goodsAddRow ? (
                <MdClose color="red" onClick={goodsAddRowClick} />
              ) : (
                <MdEdit color="green" onClick={goodsAddRowClick} />
              ))}
          </div>
          <div onClick={onChange}>
            {action ? (
              <IoIosArrowUp title="Sutraukti" color="silver" />
            ) : (
              <IoIosArrowDown color="silver" title="Išskleisti" />
            )}
          </div>
        </span>
      </div>
    </MiniBlockStyle>
  );
};

export const SimpleDownloadButton = ({ onClick, extra_text = false }) => {
  return (
    <div className="position-relative">
      <button className="btn btn-primary btn-sm w-100" onClick={onClick}>
        <FaDownload className="mr-2" title="Download" />
        Download
      </button>
      {extra_text && (
        <div
          className="position-absolute"
          style={{
            border: "0.5px solid #00709E",
            backgroundColor: "#EDF9FE",
            borderRadius: 30,
            color: "#00709E",
            fontSize: 8,
            bottom: "-8px",
            left: "50%",
            transform: "translate(-50%, 0)",
            padding: "0 4px",
          }}
        >
          DEFAULT
        </div>
      )}
    </div>
  );
};

const SaveButton = styled.button`
  width: 159px;
  height: 30px;
  border-radius: 4px;
  background-color: ${(props) => props.color};
  color: white;
  font-size: 10px;
  line-height: 14px;
  color: #ffffff;
  font-weight: 700;
`;

const ButtonOrder = styled.button`
  width: ${(props) => props.width};
  height: 32px;
  background-color: #f7951e;
  color: white;
  padding: 0.25rem 0.5rem;
  margin-left: 3px;
  float: ${(props) => props.float};
  span {
    font-size: 0.7rem;
  }
`;

const ClassicButton = styled.button`
  font-size: 12px;
  background-image: linear-gradient(to bottom right, #ef3824, #f7931e);
  border: 0;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06);
  &:not(:disabled):not(.disabled).active:focus,
  .btn-success:not(:disabled):not(.disabled):active:focus,
  .show > .btn-success.dropdown-toggle:focus,
  .btn-success.focus,
  .btn-success:focus,
  .btn-success:not(:disabled):not(.disabled).active,
  .btn-success:not(:disabled):not(.disabled):active,
  .show > .btn-success.dropdown-toggle,
  .btn-success:hover {
    transform: translateY(-1px);
    background-image: linear-gradient(to bottom right, #e43421, #eb8b1b);
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
      0 2px 4px -1px rgba(0, 0, 0, 0.2);
  }
  border-radius: 4px !important;
`;

const ExpandButton = styled.div`
  .expand_btn {
    font-size: 15px;
    border-radius: 40px;
    color: #fff;
    background-color: #000;
    border: 1px solid #000;
    padding-left: 10px;
    padding-right: 10px;
    position: relative;
    float: left;
    overflow: hidden;
    max-width: 30px;
    -webkit-transition: max-width 1s ease-in-out;
    -moz-transition: max-width 1s ease-in-out;
    -o-transition: max-width 1s ease-in-out;
    transition: max-width 1s ease-in-out;
    transition-timing-function: ease-out;
    transition-timing-function: cubic-bezier(0.29, 0.01, 0.56, 0.97);
    // background-image: linear-gradient(to bottom right, #ef3824, #f7931e);
    border: 0;
    // box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
    //   0 2px 4px -1px rgba(0, 0, 0, 0.06);

    background: #f29302;
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
    border-radius: 40px;
  }
  .expand_btn:hover {
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
      0 2px 4px -1px rgba(0, 0, 0, 0.2);
  }

  .expand_btn-text {
    display: block;
    white-space: nowrap;
    color: #fff;
  }

  .expand_btn:hover {
    // background-color: #000;
    color: #fff;
    max-width: 280px;
  }
`;

const LongButtonStyle = styled.div`
  background-color: #ffa800;
  border: 1px solid transparent;
  font-size: 15px;
  color: #ffffff;
  width: 218px;
  height: 29px;
  border-radius: 14px;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  &:focus {
    border: none;
  }
  &:active {
    border: none;
  }
`;

const MainBlockStyle = styled.div`
  border-left: 5px solid ${(props) => props.color || "orange"};
  height: ${(props) => props.height || "3rem"};
  filter: drop-shadow(0 0 4px rgba(0, 0, 0, 0.1));
  background-color: #ffffff;
  font-size: 1rem;
  line-height: 27px;
  color: #000000;
`;

const MiniBlockStyle = styled.div`
  border-left: 3px solid ${(props) => props.color || "orange"};
  height: 2rem;
  filter: drop-shadow(0 0 2px rgba(0, 0, 0, 0.1));
  background-color: #ffffff;
  font-size: 0.8rem;
  line-height: 27px;
  color: #000000;
`;

export const SearchButton = ({ onClick, text, className }) => {
  return (
    <button
      className={`btn btn-sm float-right btn-danger ${className}`}
      onClick={onClick}
      style={{
        backgroundColor: "#03B0F7",
        borderColor: "#03B0F7",
      }}
    >
      <IconSearch color="#FFF" className="text-sm cursor-pointer mr-1" />
      {text || "Search"}
    </button>
  );
};

export const ClearFilterButton = ({ onClick, className }) => {
  return (
    <ClearFilterButtonStyled
      className={`btn btn-sm float-right ${className}`}
      onClick={onClick}
    >
      <IconEraser className="text-sm cursor-pointer mr-1" />
      Clear filter
    </ClearFilterButtonStyled>
  );
};

const ClearFilterButtonStyled = styled.button`
  background-color: #1f1a54;
  color: #fff;
  border-color: #1f1a54;
`;

export const ButtonInfo = ({ onClick, className, children }) => {
  return (
    <ButtonInfoStyled
      className={`btn btn-sm float-right ${className}`}
      onClick={onClick}
    >
      {children}
    </ButtonInfoStyled>
  );
};

const ButtonInfoStyled = styled.button`
  background-color: #fff;
  color: #1f1a54;
  border-color: #1f1a54;
  &:hover,
  &:focus {
    color: #1f1a54;
  }
`;

export const SyncButton = ({ onClick, children, className, disabled }) => {
  const [loading, setLoading] = useState(false);
  const onDownloadFile = async () => {
    try {
      setLoading(true);
      const data = await onClick();
      if (data) {
        return setLoading(false);
      }
      throw new Error("ERR");
    } catch (err) {
      setLoading(false);
    }
  };
  return (
    <button
      className={className || "btn btn-sm btn-dark float-right mr-3"}
      disabled={disabled || loading}
      onClick={() => onDownloadFile()}
    >
      {loading ? (
        <>
          <span className="spinner-border spinner-border-sm"></span>
          <span> Vykdoma...</span>
        </>
      ) : (
        children
      )}
    </button>
  );
};

export const ButtonDelete2 = (props) => {
  return (
    <button
      className="btn btn-sm"
      style={{
        backgroundColor: "#E61D01",
      }}
      onClick={props.onDelete}
    >
      <FaTrash className="text-white text-sm" />
    </button>
  );
};
